__webpack_require__.p = "/wp-content/themes/wlion-2021/build/";